<!--=============================
=            IMAGENS            =
==============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Images</div>
      </base-header>
    </v-row>

    <v-row>
      <v-col class="col-12 col-md-12 col-sm-12">
        <base-card>
          <div slot="card-header">#Aspect ratio</div>
          <div slot="card-subheader">You can set a fixed aspect ratio if you want to change aspect ratio of the image.
          </div>
          <div slot="card-body">
            <div class="d-flex flex-column justify-space-between align-center mt-10 ">
              <v-slider v-model="width" class="align-self-stretch" min="200" max="500" step="1"></v-slider>

              <v-img :aspect-ratio="16/9" :width="width" src="https://cdn.vuetifyjs.com/images/parallax/material.jpg">
              </v-img>
            </div>
          </div>
        </base-card>
      </v-col>

      <v-col class="col-12 col-md-12 col-sm-12">
        <base-card>
          <div slot="card-header">#Gradients</div>
          <div slot="card-subheader">The gradient prop can be used to apply a simple gradient overlay to the image.
            More complex gradients should be written as a class on the content slot instead.</div>
          <div slot="card-body">
            <v-row>
              <v-col cols="6" sm="4">
                <v-img src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                       gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"></v-img>
              </v-col>

              <v-col cols="6" sm="4">
                <v-img src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg">
                  <div class="fill-height bottom-gradient"></div>
                </v-img>
              </v-col>

              <v-col cols="6" sm="4">
                <v-img src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg">
                  <div class="fill-height repeating-gradient"></div>
                </v-img>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>

    </v-row>
    
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data: () => ({
      width: 500,
    }),

  }
</script>
<style scoped>
  .bottom-gradient {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
  }

  .repeating-gradient {
    background-image: repeating-linear-gradient(-45deg,
        rgba(255, 0, 0, .25),
        rgba(255, 0, 0, .25) 5px,
        rgba(0, 0, 255, .25) 5px,
        rgba(0, 0, 255, .25) 10px);
  }
</style>

<!--====  End of IMAGENS  ====-->